import { render, staticRenderFns } from "./TopQuestionAndAnswer.vue?vue&type=template&id=25eb01d1&scoped=true"
import script from "./TopQuestionAndAnswer.vue?vue&type=script&lang=ts"
export * from "./TopQuestionAndAnswer.vue?vue&type=script&lang=ts"
import style0 from "./TopQuestionAndAnswer.vue?vue&type=style&index=0&id=25eb01d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_bc25730245fecb6fd7811a0f2bdc44a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb01d1",
  null
  
)

export default component.exports